module.exports = __webpack_public_path__ + "static/media/factory.49591ac0.svg";